/**
 * @description: 对 JSON.stringify 进行二次开发，扩展异常处理功能
 * @param {Object} target 宿主对象
 * @param {String} key 目标属性名
 * @return {String}
 */
export const toStringify = (target, key) => {
  let result;
  try {
    result = JSON.stringify(target[key]);
  } catch (error) {
    // JSON.stringify 失败时，返回错误信息字符串
    result = `{"code":"Error: JSON.stringify","error":"${error.message}"}`;
    // 在控制台打印警告，方便开发调试
    console.warn('[kkl-log] JSON.stringify failed:', error.message);
  }
  return result;
};
